export const services = [
  {
    id: 0,
    name: "Omówienie badań",
    time: "00:30",
    pricePln: "50",
    priceStartsFrom: false,
  },
  {
    id: 1,
    name: "Leczenie kanałowe",
    time: "02:00",
    pricePln: "300",
    priceStartsFrom: true,
  },
  {
    id: 2,
    name: "Leczenie próchnicy",
    time: "00:40",
    pricePln: "100",
    priceStartsFrom: false,
  },
  {
    id: 3,
    name: "Wypełnienie kompozytowe",
    time: "01:30",
    pricePln: "80",
    priceStartsFrom: false,
  },
  {
    id: 4,
    name: "Leczenie próchnicy",
    time: "00:20",
    pricePln: "50",
    priceStartsFrom: false,
  },
];
